import React from "react";
import { PromoBar } from "../components/PromoBar";
import { Hero } from "../components/Hero";
import { ProblemSection } from "../components/ProblemSection";
import { ValueSection } from "../components/ValueSection";
import { MidOfferSection } from "../components/MidOfferSection";
import { PersonaSection } from "../components/PersonaSection";
import { MethodSection } from "../components/MethodSection";
import { VolumesSection } from "../components/VolumesSection";
import { BonusSection } from "../components/BonusSection";
import { OfferSection } from "../components/OfferSection";
import { GuaranteeSection } from "../components/GuaranteeSection";
import { TestimonialsSection } from "../components/TestimonialsSection";
import { FaqSection } from "../components/FaqSection";
import { ClosingSection } from "../components/ClosingSection";
import { SiteFooter } from "../components/SiteFooter";
export function Landing() {
  return <div className="min-h-screen w-full overflow-x-clip bg-canvas font-sans text-ink" data-id="element-331" data-mp="m83i4g5fvpos">
      <PromoBar data-id="element-332" data-mp="2atkipzxufgy" />
      <main data-id="element-333" data-mp="2bbpcb0o220h">
        <Hero data-id="element-334" data-mp="27xm70k6horz" />
        <ProblemSection data-id="element-335" data-mp="3tgbflndtcur7" />
        <ValueSection data-id="element-336" data-mp="3tg20wvy7ya0t" />
        <MidOfferSection data-id="element-337" data-mp="3tfjwvd5beric" />
        <PersonaSection data-id="element-338" data-mp="3tiftmy5ffa57" />
        <MethodSection data-id="element-339" data-mp="3pegg8ofg0rg2" />
        <VolumesSection data-id="element-340" data-mp="3pdydd8y9zez6" />
        <BonusSection data-id="element-341" data-mp="3pf9ppx5sdv1w" />
        <OfferSection data-id="element-342" data-mp="3pguch0lv09p7" />
        <GuaranteeSection data-id="element-343" data-mp="3kfwrkg9gt1k0" />
        <TestimonialsSection data-id="element-344" data-mp="3kgoq9zyczfei" />
        <FaqSection data-id="element-345" data-mp="3khhm45vs4khv" />
        <ClosingSection data-id="element-346" data-mp="3khzt9xjzcj4k" />
      </main>
      <SiteFooter data-id="element-347" data-mp="l0rrf2s022j0" />
    </div>;
}